export default __webpack_public_path__ + "static/media/blue_studen_dashboard_bg.901e845c.jpg";